export default (previousState=null, { type, meta }) => {
  if (type === 'RA/CRUD_CHANGE_LIST_PARAMS') {
    return meta.clear ? null : meta.resource;
  }
  return previousState;
}
